import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import LazyImage from "@insite/mobius/LazyImage";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import INTArticleShareLink from "@tIntermatic/Components/INTArticleShareLink";
import Facebook from "@tIntermatic/Icons/Facebook";
import Linkedin from "@tIntermatic/Icons/Linkedin";
import Play from "@tIntermatic/Icons/Play";
import Twitter from "@tIntermatic/Icons/Twitter";
import OverflowMenu from "@tIntermatic/MobiusCustom/CustomOverflowMenu";
import LocalizedDateTime from "@tIntermatic/Overrides/Components/LocalizedDateTime";
import { NewsPageContext } from "@tIntermatic/Overrides/Pages/NewsPage";
import { ShareArticleParameter } from "@tIntermatic/Services/INTShareArticleService";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    title = "title",
    postedBy = "postedBy",
    mainImage = "mainImage",
    isVideoArticle = "isVideoArticle",
    videoLink = "videoLink",
    languageCode = "languageCode",
}

const mapStateToProps = (state: ApplicationState) => ({
    page: getCurrentPage(state),
    location: getLocation(state),
});

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.postedBy]: string;
        [fields.mainImage]: string;
        [fields.isVideoArticle]: boolean;
        [fields.videoLink]: LinkFieldValue;
        [fields.languageCode]: string;
    };
    urlRefs: string | undefined;
}

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;

// export interface ArticlesDetailsStyles

export const articlesDetailsStyles = {
    articlePageWrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 32px;
                    `,
                    css`
                        padding-top: 32px;
                    `,
                    css`
                        padding-top: 32px;
                    `,
                    css`
                        padding-top: 45px;
                    `,
                    css`
                        padding-top: 45px;
                    `,
                ])}
        `,
    },
    articleTitle: {
        css: css`
            font-weight: 300;
            letter-spacing: 0;
            text-align: center;
            color: #33333a;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 32px;
                        line-height: 38px;
                        padding: 0 30px;
                    `,
                    css`
                        font-size: 32px;
                        line-height: 38px;
                        padding: 0 30px;
                    `,
                    css`
                        font-size: 32px;
                        line-height: 38px;
                        padding: 0 30px;
                    `,
                    css`
                        font-size: 45px;
                        line-height: 61px;
                        padding: 0px 73px;
                    `,
                    css`
                        font-size: 50px;
                        line-height: 61px;
                        padding: 0px 73px;
                    `,
                ])}
        `,
    },

    overFlowMenu: {
        css: css`
            background: blue;
        `,
    },
    videoTitle: {
        css: css`
            font-weight: 300;
            letter-spacing: 0;
            text-align: center;
            color: #33333a;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 32px;
                        line-height: 38px;
                    `,
                    css`
                        font-size: 32px;
                        line-height: 38px;
                    `,
                    css`
                        font-size: 32px;
                        line-height: 38px;
                    `,
                    css`
                        font-size: 50px;
                        line-height: 61px;
                    `,
                    css`
                        font-size: 50px;
                        line-height: 61px;
                    `,
                ])}
        `,
    },

    articlePostedBy: {
        css: css`
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 17px;
            color: #33333a;
            text-align: center;
            padding: 30px 0 14px 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 30px;
                    `,
                    css`
                        padding-top: 30px;
                    `,
                    css`
                        padding-top: 30px;
                    `,
                    css`
                        padding: 30px 0 14px 0;
                    `,
                    css`
                        padding: 30px 0 14px 0;
                    `,
                ])}
        `,
    },
    image: {
        css: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-height: 152px;
                    `,
                    css`
                        max-height: 152px;
                    `,
                    css`
                        max-height: 152px;
                    `,
                    css`
                        max-height: 420px;
                    `,
                    css`
                        max-height: 420px;
                    `,
                ])}
        `,
    },

    dropdownSelect: {
        cssOverrides: {
            dropdownWrapper: css`
                width: 100%;
                max-width: 100%;
                border: 1px solid #cccccc;
                @media all and (max-width: 991px) and (min-width: 0px) {
                    border: none;
                    max-width: calc(100% + 90px);
                    @media all and (max-width: 768px) {
                        margin-left: 0;
                    }
                }

                > span {
                    text-transform: uppercase;
                    @media all and (max-width: 991px) and (min-width: 0px) {
                        font-size: 15px;
                        font-weight: 600;
                        letter-spacing: 0;
                        line-height: 23px;
                        padding-left: 5px;
                        @media all and (max-width: 768px) {
                            margin-left: 1%;
                        }
                    }
                }
                span[class^="Typography"] {
                    padding-right: 36px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 9px 9px 9px 0;
                                    margin-left: 0;
                                `,
                                css`
                                    padding: 9px 9px 9px 0;
                                    margin-left: 0;
                                `,
                                css`
                                    padding: 9px 9px 9px 0;
                                    margin-left: 0;
                                `,
                                null,
                            ],
                            "minMax",
                        );
                    }}
                }
                span[class^="IconWrapper"] {
                    left: inherit;
                    color: #33333a;
                    @media all and (max-width: 991px) and (min-width: 0px) {
                        > svg {
                            stroke-width: 1;
                        }
                    }
                }
                > ul {
                    box-sizing: border-box;
                    width: 202px;
                    border: 1px solid #e5e5e5;
                    border-radius: 6px;
                    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
                    text-transform: capitalize;
                    top: -4px;
                    left: -1px;
                    padding: 9px 0 9px 0;
                    background: rgb(255, 255, 255);
                    @media all and (max-width: 991px) and (min-width: 0px) {
                        width: 100%;
                    }
                    > div {
                        background-color: #fff;
                        color: #33333a;
                        font-size: 16px;
                        letter-spacing: 1.33px;
                        line-height: 30px;
                        box-sizing: border-box;
                        padding: 0 0 0 14px;
                        &:hover {
                            background-color: #e5e5e5;
                            color: #33333a;
                        }
                        > div {
                            margin-left: 5px;
                            > span[class^="IconWrapper"] {
                                margin-left: -8px;
                            }
                        }
                    }
                }
                div[class^="divElement"] {
                    display: inline-block;
                    margin-left: 10px;
                }
            `,
            inputSelect: css`
                width: 100%;
                font-weight: 300;
                width: 100%;
                background-color: #fff;
                border: none;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 20px;
                caret-color: transparent;
                cursor: pointer;
                &:focus {
                    border: none;
                }
            `,
        },
    },

    playIcon: {
        css: css`
            position: absolute;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        left: calc(50% - 25px);
                        height: 50px;
                        width: 50px;
                        > svg {
                            height: 50px;
                            width: 50px;
                        }
                    `,
                    css`
                        left: calc(50% - 25px);
                        height: 50px;
                        width: 50px;
                        > svg {
                            height: 50px;
                            width: 50px;
                        }
                    `,
                    css`
                        left: calc(50% - 25px);
                        height: 50px;
                        width: 50px;
                        > svg {
                            height: 50px;
                            width: 50px;
                        }
                    `,
                    css`
                        left: calc(50% - 60px);
                        height: 120px;
                        width: 120px;
                        > svg {
                            height: 120px;
                            width: 120px;
                        }
                    `,
                    css`
                        left: calc(50% - 60px);
                        height: 120px;
                        width: 120px;
                        > svg {
                            height: 120px;
                            width: 120px;
                        }
                    `,
                ])}
        `,
    },

    videoPageWrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 30px;
                        padding-top: 32px;
                    `,
                    css`
                        padding: 0 30px;
                        padding-top: 32px;
                    `,
                    css`
                        padding: 0 30px;
                        padding-top: 32px;
                    `,
                    css`
                        padding: 0 140px;
                        padding-top: 45px;
                    `,
                    css`
                        padding: 0 140px;
                        padding-top: 45px;
                    `,
                ])}
        `,
    },

    videoImage: {
        css: css`
            width: 100%;
            max-height: 474px;
        `,
    },

    modal: {
        size: 650,
        cssOverrides: {
            modalBody: css`
                box-shadow: 0 0 10px 0 rgb(0 0 0 / 0.15) !important;
                background-color: #fff !important;
                iframe {
                    width: 100%;
                    height: 390px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                height: 230px;
                            `,
                            null,
                            null,
                            null,
                            null,
                        ])}
                }
            `,

            modalTitle: css`
                border: 0px;
                padding: 20px 30px 0 30px;
            `,
            titleButton: css`
                border: none;
                background: #fff !important;
                padding: 0 !important;
                > span {
                    color: #005eb8 !important;
                    height: 30px;
                    width: 30px;
                    > svg {
                        height: 30px;
                        width: 30px;
                        stroke-width: 1.2;
                    }
                }
                &:hover {
                    background: #fff !important;
                    border: none;
                }
            `,
        },
    },
    socialWrap: {
        css: css`
            display: flex;
            align-items: center;
            width: 100%;
        `,
    },

    svgWrap: {
        css: css`
            margin-left: 1rem;
            margin-bottom: 0.5rem;
            z-index: 1;
            display: flex;
            width: 30%;
            justify-content: center;
            align-items: baseline;
        `,
    },

    socialText: {
        css: css`
            margin-left: -2rem !important;
        `,
    },
};

const styles = articlesDetailsStyles;

const INTArticlesDetails: React.FC<Props> = ({ fields, page, urlRefs }) => {
    if (!page) {
        return null;
    }

    const [urlRefState, setUrlRefState] = React.useState("");

    React.useEffect(() => {
        urlRefs = window.location.href;
        setUrlRefState(urlRefs);
    });

    const [modalOpen, setModalOpen] = React.useState(false);
    const articleModel = {
        articleDescription: fields?.title,
        articleImage: fields?.mainImage,
        altText: fields?.title,
    } as ShareArticleParameter;
    const openModal = () => {
        if (fields?.isVideoArticle) {
            setModalOpen(true);
        }
    };

    const closeModal = () => {
        setModalOpen(false);
    };
    // eslint-disable-next-line no-console
    const alertClick = () => console.log();

    return (
        <>
            <StyledWrapper
                {...(fields?.isVideoArticle ? { ...styles.videoPageWrapper } : { ...styles.articlePageWrapper })}
            >
                <StyledWrapper {...(fields?.isVideoArticle ? { ...styles.videoTitle } : { ...styles.articleTitle })}>
                    {fields?.title}
                </StyledWrapper>
                <StyledWrapper {...styles.articlePostedBy}>
                    <>
                        {fields.postedBy && (
                            <StyledWrapper
                                css={css`
                                    display: inline;
                                    text-transform: uppercase;
                                `}
                            >
                                {fields.postedBy}
                                <StyledWrapper
                                    css={css`
                                        display: inline;
                                        padding: 0 5px;
                                    `}
                                >
                                    |
                                </StyledWrapper>
                            </StyledWrapper>
                        )}

                        {page.fields["publishDate"] && (
                            <Typography>
                                <LocalizedDateTime
                                    dateTime={new Date(page.fields["publishDate"])}
                                    languageCode={fields.languageCode ? fields.languageCode : "ES"}
                                    options={{ year: "numeric", month: "numeric", day: "numeric" }}
                                />
                                <StyledWrapper
                                    css={css`
                                        display: inline;
                                        padding: 0 5px;
                                    `}
                                >
                                    |
                                </StyledWrapper>
                            </Typography>
                        )}
                        <INTArticleShareLink article={articleModel} />
                        <StyledWrapper
                            css={css`
                                display: inline;
                                padding: 0 5px;
                            `}
                        >
                            |
                        </StyledWrapper>
                        <StyledWrapper
                            css={css`
                                display: inline;

                                nav {
                                    display: inline !important;
                                }
                                ul {
                                    z-index: 1 !important;
                                    background: #ffffff !important;
                                }
                                socialIcon {
                                    border: solid red 5px;
                                }
                            `}
                        >
                            <OverflowMenu {...styles.overFlowMenu} position="middle">
                                <Clickable
                                    onClick={alertClick}
                                    target="_blank"
                                    href={`https://www.facebook.com/sharer.php?u=${urlRefState}`}
                                >
                                    <StyledWrapper {...styles.socialWrap}>
                                        <StyledWrapper {...styles.svgWrap}>
                                            <Icon src={Facebook} className="socialIcon"></Icon>
                                        </StyledWrapper>
                                        <Typography {...styles.socialText}>Facebook</Typography>
                                    </StyledWrapper>
                                </Clickable>
                                <Clickable
                                    onClick={alertClick}
                                    target="_blank"
                                    href={`http://www.twitter.com/share?url=${urlRefState}`}
                                >
                                    <StyledWrapper {...styles.socialWrap}>
                                        <StyledWrapper {...styles.svgWrap}>
                                            <Icon src={Twitter} className="socialIcon"></Icon>
                                        </StyledWrapper>
                                        <Typography {...styles.socialText}>Twitter</Typography>
                                    </StyledWrapper>
                                </Clickable>
                                <Clickable
                                    onClick={alertClick}
                                    target="_blank"
                                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${urlRefState}`}
                                >
                                    <StyledWrapper {...styles.socialWrap}>
                                        <StyledWrapper {...styles.svgWrap}>
                                            <Icon src={Linkedin} className="socialIcon"></Icon>
                                        </StyledWrapper>
                                        <Typography {...styles.socialText}>LinkedIn</Typography>
                                    </StyledWrapper>
                                </Clickable>
                            </OverflowMenu>
                        </StyledWrapper>
                    </>
                </StyledWrapper>
                <Clickable
                    data-test-selector="image"
                    css={css`
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    margin: 15px 0 36px 0;
                                `,
                                css`
                                    margin: 15px 0 36px 0;
                                `,
                                css`
                                    margin: 15px 0 36px 0;
                                `,
                                css`
                                    margin: 36px 0;
                                `,
                                css`
                                    margin: 36px 0;
                                `,
                            ])}
                    `}
                >
                    <LazyImage
                        {...(fields?.isVideoArticle ? { ...styles.videoImage } : { ...styles.image })}
                        src={fields?.mainImage}
                        altText={fields?.title}
                        onClick={openModal}
                    />
                    {fields?.isVideoArticle && <Icon src={Play} onClick={openModal} {...styles.playIcon}></Icon>}
                </Clickable>
            </StyledWrapper>
            <Modal isOpen={modalOpen} handleClose={closeModal} {...styles.modal}>
                <iframe src={fields?.videoLink?.value} frameBorder="0"></iframe>
            </Modal>
        </>
    );
};

const articlesDetails: WidgetModule = {
    component: connect(mapStateToProps)(INTArticlesDetails),
    definition: {
        group: "Common",
        displayName: "IntArticles Details",
        allowedContexts: [NewsPageContext],
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                sortOrder: 0,
                fieldType: "Translatable",
            },
            {
                name: fields.postedBy,
                displayName: "Posted By",
                editorTemplate: "TextField",
                defaultValue: "",
                sortOrder: 1,
                fieldType: "Translatable",
            },
            {
                name: fields.mainImage,
                displayName: "Main Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                sortOrder: 2,
                fieldType: "General",
            },
            {
                name: fields.isVideoArticle,
                displayName: "Is Video Article",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                sortOrder: 3,
                fieldType: "General",
            },
            {
                name: fields.videoLink,
                displayName: "Video Link",
                editorTemplate: "LinkField",
                sortOrder: 4,
                defaultValue: { type: "Url", value: "" },
                fieldType: "General",
            },
            {
                name: fields.languageCode,
                displayName: "Enter Language code for Date",
                editorTemplate: "TextField",
                defaultValue: "ES",
                sortOrder: 5,
                fieldType: "Translatable",
            },
        ],
    },
};

export default articlesDetails;
